module.exports = __webpack_public_path__ + "img/sp_logo.df64fd17.svg";